import React, { Component, Fragment, createContext } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import {
  Typography,
  Row,
  Col,
  Form,
  Table,
  Input,
  DatePicker,
  InputNumber,
  Modal,
  Icon,
  Button,
  Avatar,
  message,
} from "antd";
import {
  LoadingOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  SaveOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { alertMessage } from "../../../../../../utils/message";
import FromInput from "../../../../../../components/user/from/Input";
import {
  changeFormatdate,
  dateFormatNumber,
  disabledDate,
  yearsRangeOfEducation,
} from "../../../../../../utils/formatdate";
import moment from "moment";
import { numberWithCommas } from "../../../../../../utils/number";
import { checkLinkURL } from "../../../../../../utils/auth";
import ModalshowAllImageBase64 from "../../../../../../components/user/ModalshowAllImage/newsBase64";
import _ from "lodash";

import { IconButton, Span } from "../../../../../../components/element";

const yearsRange = yearsRangeOfEducation();

const EditableContext = React.createContext();

class EditableCell extends React.Component {
  handleChange = (value, dataIndex, record, getFieldValue, setFieldsValue) => {
    if (dataIndex === "studyFeeDetailPrice") {
      const studyFeeDetailActualPrice =
        getFieldValue("studyFeeDetailActualPrice") ||
        record.studyFeeDetailActualPrice;
      if (value > studyFeeDetailActualPrice)
        setFieldsValue({ studyFeeDetailActualPrice: value });
    }
  };

  getInput = ({
    inputType,
    dataIndex,
    record,
    getFieldValue,
    setFieldsValue,
    index,
  }) => {
    switch (inputType) {
      case "number":
        return (
          <InputNumber
            min={0}
            max={9999999}
            formatter={(item) => item.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
            className="input-number"
            onChange={(value) =>
              this.handleChange(
                value,
                dataIndex,
                record,
                getFieldValue,
                setFieldsValue
              )
            }
          />
        );
      case "date":
        return (
          <DatePicker
            format={dateFormatNumber(getFieldValue(dataIndex))}
            className="w-100"
            placeholder="เลือกวันที่"
            allowClear={false}
            disabledDate={disabledDate}
          />
        );
      case "uploadFile":
        return (
          <>
            <label
              for={`input-file-${index}`}
              className="custom-file-upload"
              style={{ lineHeight: 1.5 }}
            >
              <p
                className="py-2 px-4 mb-0"
                align={"center"}
                style={{ backgroundColor: "#8d0e14", color: "#fff" }}
              >
                อัปโหลด
              </p>
              <p style={{ fontSize: "12px" }} className="my-2">
                <p style={{ textAlign: "center", margin: 0 }}>
                  แนบไฟล์ที่เป็นนามสกุล
                </p>
                <p style={{ textAlign: "center", margin: 0 }}>
                  .jpg, .png หรือ .pdf
                </p>
              </p>
            </label>
            <input
              for={`input-file-${index}`}
              className="input-file"
              type="file"
              accept="image/png, image/jpeg, application/pdf"
              // onChange={(e) =>
              //   this.handleAddUploadsFile(e.target.files, arrayId)
              // }
            />
          </>
        );
      // break;
      default:
        return <Input />;
    }
  };

  requiredMessage(field) {
    let message = "";
    switch (field) {
      case "studyFeeDetailDescription":
        message = "รายละเอียด";
        break;
      case "studyFeeDetailSlipDate":
        message = "วันที่ในใบเสร็จ";
        break;
      case "studyFeeDetailPrice":
        message = "จำนวนเงินในใบเสร็จ (บาท)";
        break;
      case "studyFeeDetailActualPrice":
        message = "จำนวนเงินที่เบิกได้ (บาท)";
        break;
      default:
        break;
    }
    return `กรุณาระบุ ${message}`;
  }

  renderCell = ({ getFieldDecorator, getFieldValue, setFieldsValue }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;

    const isDate = dataIndex === "studyFeeDetailSlipDate";
    const getField = record?.[dataIndex] || "";
    const initialValue = isDate ? moment(getField) : getField;

    console.log("dataIxxvxvvxndex", dataIndex)
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required:
                    dataIndex === "studyFeeDetailInvoiceNo" ? false : true,
                  message: "",
                },
              ],
              initialValue,
            })(
              this.getInput({
                inputType,
                dataIndex,
                record,
                getFieldValue,
                setFieldsValue,
                index,
              })
            )}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

class InPaymentDetail2 extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: "ลำดับ",
        width: 80,
        align: "center",
        render: (item, record, index) => index + 1,
      },
      {
        title: <Span req>รายละเอียด</Span>,
        dataIndex: "studyFeeDetailDescription",
        width: 200,
        align: "center",
        editable: true,
        render: (item) => <Input defaultValue={item} disabled={true} />,
      },
      {
        title: "เลขที่ใบเสร็จ",
        dataIndex: "studyFeeDetailInvoiceNo",
        width: 200,
        align: "center",
        editable: true,
        render: (item) => <Input defaultValue={item} disabled={true} />,
      },
      {
        title: <Span req>วันที่ในใบเสร็จ</Span>,
        dataIndex: "studyFeeDetailSlipDate",
        width: 200,
        align: "center",
        editable: true,
        render: (item) => (
          <DatePicker
            defaultValue={item}
            disabled={true}
            format={item ? dateFormatNumber(item) : "-"}
            className="w-100"
            allowClear={false}
          />
        ),
      },
      {
        title: <Span req>จำนวนเงินในใบเสร็จ (บาท)</Span>,
        dataIndex: "studyFeeDetailPrice",
        width: 200,
        align: "center",
        editable: true,
        render: (item) => (
          <InputNumber
            defaultValue={item}
            disabled={true}
            formatter={(item) => item.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            className="input-number"
          />
        ),
      },
      {
        title: <Span req>จำนวนเงินที่เบิกได้ (บาท)</Span>,
        dataIndex: "studyFeeDetailActualPrice",
        width: 200,
        align: "center",
        editable: true,
        render: (item) => (
          <InputNumber
            defaultValue={item}
            disabled={true}
            formatter={(item) => item.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            className="input-number"
          />
        ),
      },
      {
        title: <Span req>แนบใบเสร็จ</Span>,
        dataIndex: "studyEducationFeeAttachfile",
        align: "center",
        width: 200,
        editable: true,
        render: (item, record, index) => {
          const { studyEducationFeeAttachfile } = record;
          if (!_.isEmpty(studyEducationFeeAttachfile)) {
            return (
              <p
                onClick={() =>
                  this.openModal(studyEducationFeeAttachfile, "เอกสาร", index)
                }
                style={{ cursor: "pointer" }}
                className="btn-show-fileuploads mb-0"
              >
                ดูไฟล์เอกสารแนบ
              </p>
            );
          }
          return "-";
        },
      },
      {
        title: "จัดการ",
        width: 120,
        align: "center",
        render: (item, record, index) => {
          const keyId = record?.studyEducationFeeDetailId;
          const { isMatch, btnDelDisabled } = this.keyChecker(keyId);
          return (
            <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
              {isMatch ? (
                <EditableContext.Consumer>
                  {(form) => (
                    <IconButton
                      bg="blue"
                      onClick={() => this.saveRow(form, keyId)}
                    >
                      <SaveOutlined />
                    </IconButton>
                  )}
                </EditableContext.Consumer>
              ) : (
                <IconButton
                  bg="blue"
                  disabled={!!this.state.editingKey}
                  onClick={() =>
                    this.editRow(record?.studyEducationFeeDetailId)
                  }
                >
                  <EditOutlined />
                </IconButton>
              )}
              <IconButton
                bg="red"
                disabled={btnDelDisabled}
                onClick={() => this.deleteRow(record)}
              >
                <DeleteOutlined />
              </IconButton>
            </div>
          );
        },
      },
    ];
    this.state = {
      dataSource: this.mapOriginalData(
        props.rawData?.studyEducationFeeDetail || []
      ),
      editingKey: "",
      isEditing: false,
      isOpen: false,
      modalTitle: null,
      imageData: [],
      rowIndex: null,
    };
  }

  mapOriginalData(data) {
    let studyEducationFeeAttachfile = [];
    return data.map(
      ({
        studyEducationFeeId,
        studyEducationFeeDetailId,
        studyFeeDetailDescription,
        studyFeeDetailInvoiceNo,
        studyFeeDetailSlipDate,
        studyFeeDetailPrice,
        studyFeeDetailActualPrice,
        studyEducationFeeAttachfile: originalAttachfile,
      }) => {
        studyEducationFeeAttachfile = originalAttachfile
          .filter(({ isDeleted }) => isDeleted !== 1)
          .map(
            ({ studyFeeAttachmentId, studyFeefilePath, studyFeefileType }) => {
              return {
                fileIdBase64: studyFeeAttachmentId,
                fileBase64: studyFeefilePath,
                fileMimeType: studyFeefileType,
              };
            }
          );
        return {
          studyEducationFeeId,
          studyEducationFeeDetailId,
          studyFeeDetailDescription,
          studyFeeDetailInvoiceNo,
          studyFeeDetailSlipDate: moment(studyFeeDetailSlipDate),
          studyFeeDetailPrice,
          studyFeeDetailActualPrice,
          studyEducationFeeAttachfile,
        };
      }
    );
  }

  keyChecker(keyId) {
    const { editingKey, isEditing } = this.state;
    const isMatch = editingKey === keyId;
    const btnDelDisabled = isMatch
      ? isEditing
        ? true
        : false
      : !(!!editingKey === false);
    return { isMatch, btnDelDisabled };
  }

  editRow(keyId) {
    this.setState({ editingKey: keyId, isEditing: true });
  }

  insertRow() {
    const { studyEducationFeeId } =
      this.props?.rawData?.studyEducationFeeId || "";
    const { dataSource } = this.state;
    const currentDate = moment();
    const timestamp = String(currentDate.unix());
    const newRow = {
      studyEducationFeeId,
      studyEducationFeeDetailId: timestamp,
      studyFeeDetailDescription: "",
      studyFeeDetailInvoiceNo: "",
      studyFeeDetailSlipDate: currentDate,
      studyFeeDetailPrice: 0,
      studyFeeDetailActualPrice: 0,
      studyEducationFeeAttachfile: null,
    };
    dataSource.push(newRow);
    this.setState({ editingKey: timestamp, dataSource });
  }

  saveRow(form, keyId) {
    form.validateFields((error, row) => {
      if (error) return;
      const { dataSource } = this.state;
      const index = dataSource.findIndex(
        ({ studyEducationFeeDetailId: sefdId }) => sefdId === keyId
      );
      if (index > -1) {
        const item = dataSource[index];
        dataSource.splice(index, 1, {
          ...item,
          ...row,
        });
      } else {
        dataSource.push(row);
      }
      this.setState({ editingKey: "", isEditing: false, dataSource });
    });
  }

  deleteRow(record) {
    const targetId = record.studyEducationFeeDetailId;
    const { dataSource } = this.state;
    const newData = dataSource.filter(
      ({ studyEducationFeeDetailId: sefdId }) => sefdId !== targetId
    );
    this.setState({ editingKey: "", dataSource: newData });
  }

  mergedColumns() {
    const checkType = (str) => {
      switch (str) {
        case "studyFeeDetailPrice":
        case "studyFeeDetailActualPrice":
          return "number";
        case "studyFeeDetailSlipDate":
          return "date";
        case "studyEducationFeeAttachfile":
          return "uploadFile";
        default:
          return "text";
      }
    };

    return this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => {
          const { isMatch } = this.keyChecker(
            record?.studyEducationFeeDetailId
          );
          return {
            record,
            inputType: checkType(col.dataIndex),
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isMatch,
          };
        },
      };
    });
  }

  openModal(data, title, index) {
    this.setState({
      isOpen: true,
      modalTitle: title,
      imageData: data,
      rowIndex: index,
    });
  }

  closeModal = async () => {
    this.setState({
      isOpen: false,
      modalTitle: null,
      imageData: [],
      rowIndex: null,
    });
  };

  componentDidMount() {
    console.log("props:", this.props);
    console.log("dataSource:", this.state.dataSource);
  }

  render() {
    const { rawData, form } = this.props;
    const { dataSource, editingKey, isOpen, modalTitle, imageData, rowIndex } =
      this.state;
    const columns = this.mergedColumns();

    return (
      <>
        <ModalshowAllImageBase64
          showModal={isOpen}
          title={modalTitle}
          data={imageData}
          hideModal={this.closeModal}
          dataArrayId={rowIndex}
          imageDatabase={false}
        />
        <Row gutter={16}>
          <Col span={24} className="mb-3">
            <Typography.Text className="color-red" style={{ fontSize: "18px" }}>
              ข้อมูลการเบิกค่าธรรมเนียมการศึกษา
            </Typography.Text>
          </Col>
          <Col span={12} className="mb-2">
            <Form.Item label="วันที่ยื่นเรื่อง" className="mb-0">
              {form.getFieldDecorator("submitDate", {
                initialValue: rawData?.submitDate
                  ? moment(rawData?.submitDate)
                  : "-",
              })(
                <DatePicker
                  format={dateFormatNumber(form.getFieldValue("submitDate"))}
                  className="w-100"
                  disabledDate={disabledDate}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12} className="mb-2">
            <Form.Item label="ปีการศึกษา" className="mb-0">
              {form.getFieldDecorator("studyEducationFeeYear", {
                initialValue: rawData?.studyEducationFeeYear || "-",
              })(
                <InputNumber
                  min={yearsRange.min}
                  max={yearsRange.max}
                  step={1}
                  decimalSeparator={0}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12} className="mb-2">
            <Form.Item label="ภาคการศึกษาที่" className="mb-0">
              {form.getFieldDecorator("studyEducationFeeTerm", {
                initialValue: rawData?.studyEducationFeeTerm || "-",
              })(<InputNumber min={1} max={2} step={1} decimalSeparator={0} />)}
            </Form.Item>
          </Col>
          <Col span={12} className="mb-2">
            <Form.Item label="ช่องทางการจ่ายเงิน" className="mb-0">
              {form.getFieldDecorator("paymentType", {
                initialValue: rawData?.paymentType || "-",
              })(<Input disabled={true} />)}
            </Form.Item>
          </Col>
          <Col md={24} className="mb-2 mt-2">
            <Form.Item label={"ใบเสร็จ"} className="mb-0" required>
              <EditableContext.Provider value={form}>
                <Table
                  components={{
                    body: {
                      cell: EditableCell,
                    },
                  }}
                  locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  scroll={{ x: "max-content" }}
                  rowKey="studyEducationFeeDetailId"
                />
              </EditableContext.Provider>
            </Form.Item>
          </Col>
          <Col span={24} align="right" className="mb-2">
            {`รวมยอดเงินที่เบิกได้จริง ${numberWithCommas(
              rawData?.studyEducationActualPrice || 0
            )} บาท`}
          </Col>
          <Col span={24}>
            <Row gutter={16} justify="space-between">
              <Col xs={14} md={12}>
                ** ต้องมีการกดปุ่มบันทึกแต่ละ record ก่อน
                จึงจะสามารถเพิ่มข้อมูลหรือยื่นเรื่องได้
              </Col>
              <Col xs={10} md={12} align="right">
                <Button
                  type="primary btn-color-default btn-clear"
                  onClick={() => this.insertRow()}
                  disabled={!!editingKey}
                >
                  เพิ่มแถว
                </Button>
              </Col>
            </Row>
          </Col>
          <Col md={24} className="mb-2">
            <Form.Item label={"หมายเหตุ"} className="mb-0">
              {form.getFieldDecorator("studyEducationRemark", {
                initialValue: rawData?.studyEducationRemark || "",
              })(<Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />)}
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  }
}

const WrappedInPaymentDetail2 = Form.create()(InPaymentDetail2);
export default withApollo(WrappedInPaymentDetail2);
